<template>
  <Container title="Log In">
    <form @submit.prevent="submit">
      <div class="form-container p-fluid">
        <FormField :title="t('global.login_email')" v-model="email" :required="true" placeholder="Enter your email" :error="getError('email')" type="email"/>

        <div class="forgot-password">
          <router-link :to="{name: 'password.request'}">Forgot password?</router-link>
        </div>

        <FormField :title="t('global.login_password')" v-model="password" :required="true" placeholder="Create your password" :error="getError('password')" componentType="password" :toggleMask="true" :feedback="false" />

        <div class="button-container underline-links">
          <Button type="submit" :label="t('global.log_in')" :loading="busy" class="p-button-md"></Button>
          <span>
            {{ t('global.dont_have_account') }}
            <router-link :to="{name: 'register.brand'}">{{ t('global.sign_up_here') }}</router-link>
          </span>
        </div>
      </div>
    </form>
  </Container>
</template>

<script setup>
import {ref} from "vue";
import {useForm} from "../../hooks/useForm";
import {useRoute, useRouter} from "vue-router";
import {login} from "../../services/Auth";
import FormField from "../../components/FormField";
import Container from "./Container";
import {useI18n} from 'vue-i18n';

const email = ref('');
const password = ref('');

const {t} = useI18n({useScope: 'global'})
const route = useRoute();
const router = useRouter();

const {busy, submit, getError} = useForm(async () => {
  await login(email.value, password.value);

  if (route.query.redirect) {
    await router.push(String(route.query.redirect));
  } else {
    await router.push({name: 'dashboard'});
  }
});

</script>

<style lang="scss" scoped>
@import "../../assets/sass/theme_variables";

.button-container {
  button {
    display: block;
    width: 100%;
    margin-bottom: toRem(16);
  }
}

.forgot-password {
  transform: translateY(100%);
  text-align: right;
}

::v-deep(.p-field) {
  label {
    position: relative;
  }
}

</style>

